import React from 'react'

const GlobalDivider = ({className=''}:{className?:string}) => {
  return (
    <div className={`border-t-0 border border-[#222222] ${className}`} />
  )
}

export default GlobalDivider